import './story-logo.scss';

import StoryLogo from './StoryLogo';

export default StoryLogo;
